<template>
  <div>
    <Form ref="form" :onSubmit="onSubmit" :onSuccess="onSuccess">

      <h1>{{ i18n.app.components.contract_edit_order_number.header }} - {{ options.model.contract_number }}</h1>

      <div>
        <TextInput :model="model" :label="i18n.app.components.contract.order_number" :placeholder="i18n.app.components.contract.order_number" name="order_number" minHeight='150px' />
      </div>
      <div class="row">
        <div class="col-md-6">
          <a @click="onCancelClick" tabindex="0" class="btn btn-primary">{{ i18n.app.common.cancel }}</a>
        </div>
        <div class="col-md-6 text-right">
          <a @click="onSubmitClick" class="btn btn-secondary">{{ i18n.app.common.confirm }}</a>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import DialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';
import { TextInput, Form } from '@/components/common/form';
import ContractService from "@/services/ContractService";

const contractService = new ContractService();

export default {
  name: 'contract-edit-order-number-dialog',
  props: ['options'],
  mixins: [DialogMixin],
  components: {
    Form,
    TextInput
  },
  data() {
    return {
      model: {
        id: this.options.model.id,
        order_number: this.options.model.order_number
      }
    }
  },
  methods: {
    onSubmitClick() {
      this.$refs.form.submit(this.model);
    },
    onSubmit() {
      return contractService.editOrderNumber(this.model.id, this.model.order_number)
    },
    onSuccess(model) {
      this.proceed(model);
    },
    onCancelClick() {
      this.cancel(); // included in DialogMixin
    }
  }
}
</script>
